import { axiosDS } from '@pp/axios'
import { urls } from 'Constants/Urls'
import { RequestParams, ResponseCatalog } from 'Models'
import {
	CreateRbidosRequest,
	RbidosRequest,
	RestartRbidosRequestModel,
	InnDataModel,
	RemoteDocumentModel,
	CopyRbidosRequestModel,
	MccCodeType,
	MccGroupType,
} from 'Pages/registratorCabinet'
import { FieldNames } from 'Constants/FieldNames'
import { RbidosLeadModel, AFTER_SBER_ID_USER_INFO, RbidosLeadCreateModel } from 'Pages/lead'

export const orderEditApi = {
	createRbidosRequest: async (data: CreateRbidosRequest) => {
		const res = await axiosDS().post<RbidosRequest>(urls.cabinet.rbidosRequest, { data })
		return res.data
	},
	createRbidosLead: async (data: RbidosLeadCreateModel) => {
		const res = await axiosDS().post<RbidosLeadModel>(urls.rbidos_lead.index, { data })
		return res.data
	},
	getRbidosLeads: async (params: RequestParams) => {
		const res = await axiosDS().get<ResponseCatalog<RbidosLeadModel>>(urls.rbidos_lead.index, {
			params,
		})
		return res.data
	},
	getSberIdInfo: async (id: number) => {
		const res = await axiosDS().get<AFTER_SBER_ID_USER_INFO>(
			urls.rbidos_lead.user_info_after_sber_id.replace(':id', id.toString())
		)
		return res.data
	},
	getEditRbidosRequest: async (id: string | number) => {
		const res = await axiosDS().get<RbidosRequest>(`${urls.cabinet.rbidosRequest}/${id}`)
		return res.data
	},
	updateEditRbidosRequest: async (
		id: number | string,
		data: RbidosRequest | { [FieldNames.PASSPORT_FULL]: boolean }
	) => {
		const res = await axiosDS().put<RbidosRequest>(`${urls.cabinet.rbidosRequest}/${id}`, { data })
		return res.data
	},
	pushEditRbidosRequest: async (
		id: number | string,
		data: RbidosRequest | { [FieldNames.PASSPORT_FULL]: boolean }
	) => {
		const res = await axiosDS().post<RbidosRequest>(`${urls.cabinet.rbidosRequest}/${id}/push`, {
			data,
		})
		return res.data
	},
	rollbackStatusRbidosRequest: async (id: number | string) => {
		const res = await axiosDS().post<RbidosRequest>(
			`${urls.cabinet.rbidosRequest}/${id}/rollback_status`
		)
		return res.data
	},
	getInnRbidosRequest: async (data: InnDataModel) => {
		const res = await axiosDS().post<{ inn: string | number }>(urls.cabinet.inn, data)
		return res.data
	},
	sendRemoteDocuments: async (data: RemoteDocumentModel) => {
		const res = await axiosDS().post(`${urls.cabinet.remote_docs_upload}`, { data })
		return res.data
	},

	copyRbidosRequest: async (id: number, data: CopyRbidosRequestModel | {}) => {
		const res = await axiosDS().post<RbidosRequest>(
			`${urls.cabinet.rbidosRequest}/${id}/copy_request`,
			{ data }
		)
		return res.data
	},
	restartApi: async (id: number, data: Omit<RestartRbidosRequestModel, 'id'>) => {
		const res = await axiosDS().post(`${urls.cabinet.rbidosRequest}/${id}/restart`, data)
		return res.data
	},
	deleteRbidosRequest: async (id: number) => {
		const res = await axiosDS().delete<RbidosRequest>(`${urls.cabinet.rbidosRequest}/${id}`)
		return res.data
	},
	restoreRbidosRequest: async (id: number) => {
		const res = await axiosDS().put<RbidosRequest>(`${urls.cabinet.rbidosRequest}/${id}/restore`)
		return res.data
	},
	getMccCodes: async (params: RequestParams) => {
		const res = await axiosDS().get<ResponseCatalog<MccCodeType>>(urls.cabinet.mcc_code, {
			params,
		})
		return res.data
	},
	sendStatusPaymentCallback: async (data: { orderId: string }) => {
		const res = await axiosDS().post(urls.cabinet.paymentCallback, {
			data,
		})
		return res.data
	},
	getMccGroups: async (params: RequestParams) => {
		const res = await axiosDS().get<ResponseCatalog<MccGroupType>>(urls.cabinet.mcc_group, {
			params,
		})
		return res.data
	},
}
